<div class="modal-header">
  <span class="modal-title">Camera</span>
  <button type="button" class="btn-close " aria-label="Close" (click)="closeModal()" data-test="close-camera-modal">
  </button>
</div>
<div class="modal-body">
<iframe src="https://viennaairport.panomax.com" style="width: 100%; height: 100%; border: none;" allowfullscreen></iframe>
</div>
